/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import intl from 'react-intl-universal';

import AppNavbar from '../InternetNavbar';
import AppFooter from '../../components/AppFooter';
import NotFound from "../../components/NotFound";
import Loading from "../../components/Loading";
import { getCountryName } from "../place/GeoCountries";

class IspList extends Component {

    constructor(props) {
        super(props);
        this.state = { isps: [], isLoading: true, isFound: false };
    }

    componentDidMount() {
        this.setState({ isLoading: true, isFound: false });

        fetch('/rest/internet/isps/' + this.props.match.params.country)
            .then(response => response.json())
            .then(data => {
                this.setState({ isps: data, isLoading: false, isFound: (data.length > 0) });
            });
    }


    componentWillUpdate() {

        if (typeof window.initDataTable === "function") {
            window.initDataTable("#ispDataTable", true);
        }
    }


    render() {
        const { isps, isLoading, isFound } = this.state;

        if (isLoading) {
            return <Loading />;
        }

        if (!isFound) {
            return <NotFound />;
        }

        const groupList = isps.map(isp => {
            const address = `${isp.websiteUrl || ''}`;
            const logoUrl = isp.logoImageUrl;
            return <tr key={isp.id}>
                <td><img src={logoUrl} alt={isp.name + " logo"} width={32} /></td>
                <td style={{ whiteSpace: 'nowrap' }}>{isp.countryCode}</td>
                <td style={{ whiteSpace: 'nowrap' }}>{isp.id}</td>
                <td style={{ whiteSpace: 'nowrap' }}>{isp.name}</td>
                <td>{address}</td>
                <td>
                    <div className="btn-group" role="group" aria-label="ISP List">
                        <Link className="btn btn-xs btn-primary" to={"/provider/" + isp.id + "/" + getCountryName(isp.countryCode)}>
                            {intl.get('generic_view')}
                        </Link>
                    </div>
                </td>
            </tr>
        });

        return (
            <div>
                <AppNavbar />
                <div className="container space-2">
                    <div className="pb-6 mb-6">
                        <h1 className="font-weight-semi-bold">Internet Providers in {getCountryName(this.props.match.params.country)}</h1>
                        <p className="font-weight-normal mb-0" style={{ fontSize: '1.125rem' }}>{intl.get('isp_list_title')}</p>
                    </div>

                    <div className="table-responsive-md">
                        <table id="ispDataTable" className="table table-borderless table-striped md-4">
                            <thead>
                                <tr>
                                    <th width="10%">{intl.get('generic_logo')}</th>
                                    <th width="10%">{intl.get('generic_country')}</th>
                                    <th width="20%">{intl.get('generic_id')}</th>
                                    <th width="20%">{intl.get('generic_name')}</th>
                                    <th>{intl.get('generic_website')}</th>
                                    <th width="10%">{intl.get('generic_actions')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {groupList}
                            </tbody>
                        </table>
                    </div>

                    {/* <div className="pb-6 mb-6">
                        <nav id="datatablePagination" aria-label="Activity pagination"/>
                        <small id="datatableInfo" className="text-secondary"/>
                    </div> */}

                </div>

                <AppFooter />

            </div>
        );
    }
}

export default IspList;